import type { Theme } from "@mui/material/styles";
import type { Settings } from "react-slick";

export enum HowManyCards {
  OneToFive = "OneToFive",
  OneToThree = "OneToThree",
  OneToTwo = "OneToTwo",
}

/**
 * Slick `responsive` breakpoints keyed by {@link HowManyCards} layout preset.
 */
export function getCarouselResponsivePresets(
  theme: Theme,
): Record<HowManyCards, Settings["responsive"]> {
  return {
    [HowManyCards.OneToFive]: [
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: theme.breakpoints.values.xl,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
    [HowManyCards.OneToThree]: [
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: theme.breakpoints.values.xl,
        settings: {
          slidesToShow: 2.5,
        },
      },
    ],
    [HowManyCards.OneToTwo]: [
      {
        breakpoint: theme.breakpoints.values.xs,
        settings: {
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: theme.breakpoints.values.xl,
        settings: {
          slidesToShow: 1.3,
        },
      },
    ],
  };
}
